import { render, staticRenderFns } from "./newMemberLevel.vue?vue&type=template&id=0654f4ae&scoped=true&"
import script from "./newMemberLevel.vue?vue&type=script&lang=js&"
export * from "./newMemberLevel.vue?vue&type=script&lang=js&"
import style0 from "./newMemberLevel.vue?vue&type=style&index=0&id=0654f4ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0654f4ae",
  null
  
)

export default component.exports